module.exports = __webpack_public_path__ + "static/media/no_img.f3d0a9a0.png";